class PopupPanel extends HTMLElement {
  _id = '';

  /** @param {MouseEvent} e */
  _onDocClick = (e) => {
    const target = e.target;
    if (!(target instanceof Element)) return;

    if (target.closest(`[data-popup-trigger="${this._id}"]`)) {
      this.open();
      return;
    }

    if (target.matches(`[data-popup-overlay="${this._id}"]`)) {
      this.close();
    }
  };

  /** @param {KeyboardEvent} e */
  _onKeydown = (e) => {
    if (e.key === 'Escape' && this.hasAttribute('open')) this.close();
  };

  connectedCallback() {
    this._id = this.getAttribute('popup-id') ?? '';

    this.addEventListener('click', (e) => {
      const target = e.target;
      if (target instanceof Element && target.closest('.popup-panel__close')) {
        this.close();
      }
    });

    document.addEventListener('click', this._onDocClick);
    document.addEventListener('keydown', this._onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onDocClick);
    document.removeEventListener('keydown', this._onKeydown);
  }

  open() {
    this.setAttribute('open', '');
    document.body.classList.add('popup-open');
  }

  close() {
    this.removeAttribute('open');
    if (!document.querySelector('popup-panel[open]')) {
      document.body.classList.remove('popup-open');
    }
  }
}

customElements.define('popup-panel', PopupPanel);
